import { ChildrenProp } from '@/common/types_and_interfaces.ts'
import { cn } from '@/common/utilities.ts'
import { Link, useMatch } from 'react-router-dom'
import { AppRoutePaths } from '@/routing/route_paths.ts'
import { SimpleLeftArrowIcon } from '@/common/icons/arrows.tsx'
import { useTranslation } from 'react-i18next'

export const WizardStepTitle = ({ children }: ChildrenProp) => {
  const { t: translate } = useTranslation()
  const locationIsChecklist = useMatch(
    AppRoutePaths.program_application.wizard.index
  )
  return (
    <div className="pb-4 pt-8 grid grid-cols-3 items-end">
      <Link
        to={AppRoutePaths.program_application.wizard.index}
        className={cn(
          'ms-3 flex items-center text-primary font-semibold hover:underline',
          {
            invisible: locationIsChecklist != null,
          }
        )}
      >
        <SimpleLeftArrowIcon className="text-sm mr-2"></SimpleLeftArrowIcon>
        {translate('back_to_checklist')}
      </Link>
      <h1 className="font-medium text-2xl text-center">{children}</h1>
    </div>
  )
}
